import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useUserStore } from "@/stores/userStore";
import { withPrefix } from "@/utils/redirect";
import Alert from "@/components/Alert.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CenterFrame',
    props: {
        id: { default: "frame" },
        src: { default: "" },
        isPreview: { type: Boolean, default: false }
    },
    emits: ["load"],
    setup(__props, { emit }) {
        const props = __props;
        const { isAdmin } = storeToRefs(useUserStore());
        const srcWithRoot = computed(() => withPrefix(props.src));
        const sanitizedImport = ref(false);
        const sanitizedToolId = ref(false);
        const isLoading = ref(true);
        watch(() => srcWithRoot.value, async () => {
            sanitizedImport.value = false;
            sanitizedToolId.value = false;
            if (props.isPreview) {
                try {
                    const response = await fetch(srcWithRoot.value, { method: "HEAD" });
                    const isImported = response.headers.get("x-sanitized-job-imported");
                    const toolId = response.headers.get("x-sanitized-tool-id");
                    if (isImported !== null) {
                        sanitizedImport.value = true;
                    }
                    else if (toolId !== null) {
                        sanitizedToolId.value = toolId;
                    }
                }
                catch (e) {
                    // I guess that's fine and the center panel will show something
                    console.error(e);
                }
            }
        }, { immediate: true });
        const plainText = "Contents are shown as plain text.";
        const sanitizedMessage = computed(() => {
            if (sanitizedImport.value) {
                return `Dataset has been imported. ${plainText}`;
            }
            else if (sanitizedToolId.value) {
                return `Dataset created by a tool that is not known to create safe HTML. ${plainText}`;
            }
            return undefined;
        });
        function onLoad(ev) {
            isLoading.value = false;
            const iframe = ev.currentTarget;
            const location = iframe?.contentWindow && iframe.contentWindow.location;
            try {
                if (location && location.host && location.pathname != "/") {
                    emit("load");
                }
            }
            catch (err) {
                console.warn("CenterFrame - onLoad location access forbidden.", ev, location);
            }
        }
        return { __sfc: true, emit, props, isAdmin, srcWithRoot, sanitizedImport, sanitizedToolId, isLoading, plainText, sanitizedMessage, onLoad, Alert, LoadingSpan };
    }
});
